import React, { Component } from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';

export default class LazyRoute extends Component {
    static defaultProps = {
        onLoaded: noop,
    };

    static propTypes = {
        onLoaded: PropTypes.func.isRequired,
        component: PropTypes.object.isRequired,
    };

    state = {
        loaded: false,
    };

    componentDidMount() {
        this.props.component.then((module) => {
            if (!this._isUnmounted) {
                this.component = module.default;
                this.props.onLoaded();
                this.setState({ loaded: true });
            }
        });
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    _isUnmounted = false;

    render() {
        const { loaded } = this.state;

        if (loaded === true) {
            return <this.component {...this.props} />;
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/lazy-route/index.js